const ToCamel = (s) => {
    return s.replace(/([-_][a-z])/ig, ($1) => {
        return $1.toUpperCase()
            .replace('-', '')
            .replace('_', '');
    });
};

const IsArray = function (a) {
    return Array.isArray(a);
};

const IsObject = function (o) {
    return o === Object(o) && !IsArray(o) && typeof o !== 'function';
};

export const KeysToCamel = (o) => {
    if (IsObject(o)) {
        const n = {};

        Object.keys(o)
            .forEach((k) => {
                n[ToCamel(k)] = KeysToCamel(o[k]);
            });

        return n;
    } else if (IsArray(o)) {
        return o.map((i) => {
            return KeysToCamel(i);
        });
    }

    return o;
};